module.exports = __webpack_public_path__ + "static/img/buy_more_question.98090cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/buy_pop_up/buy_more_question.png
// module id = 1zUB
// module chunks = 1